/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Flex from "../ui/Flex";
import Stack from "../ui/Stack";
import SearchField from "../ui/form/SearchField";
import SelectField from "../ui/form/SelectField";
import FilterButton from "./FilterButton";
import FilterTags from "./FilterTags";

const StyledFilterBar = styled(Flex)`
  margin-bottom: 8px;
  @media (max-width: 425px) {
    flex-direction: column;
  }
`;

const SearchItem = styled(Flex)`
  width: 100%;
`;

const sortOptions = [
  { value: "", label: "Default" },
  { value: "name-asc", label: "Name (A to Z)" },
  { value: "name-desc", label: "Name (Z to A)" },
  { value: "price-asc", label: "Price (Low to High)" },
  { value: "price-desc", label: "Price (High to Low)" },
];

const SearchSortBar = ({
  searchValue, sortBy, onSearchChange, onSortChange,
  filterGroups, selectedFilters, onFilterChange, onClearFilters, filterNote,
}) => (
  <Stack $gap="0rem">
    <StyledFilterBar $gap="0.5rem">
      <SearchItem $gap="0.5rem">
        <SearchField name="search" placeholder="Search" value={searchValue} onChange={(e) => onSearchChange(e.target.value)} />
        <FilterButton filterGroups={filterGroups} selectedFilters={selectedFilters} onFilterChange={onFilterChange} onClearFilters={onClearFilters} note={filterNote} />
      </SearchItem>
      <SelectField label="Sort by" value={sortBy} options={sortOptions} onChange={onSortChange} />
    </StyledFilterBar>
    <FilterTags filterGroups={filterGroups} selectedFilters={selectedFilters} onFilterChange={onFilterChange} onClearFilters={onClearFilters} />
  </Stack>
);

export { sortOptions };
export default SearchSortBar;